import React, { Fragment } from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function ForWhomSection() {
  const points = [<Fragment data-id="element-116">
      Querés bajar de peso, pero <strong data-id="element-117">no sabés por dónde empezar.</strong>
    </Fragment>, <Fragment data-id="element-118">
      Ya intentaste hacer dieta varias veces y{' '}
      <strong data-id="element-119">siempre terminaste abandonando.</strong>
    </Fragment>, <Fragment data-id="element-120">
      Sentís que antes te veías mejor y querés{' '}
      <strong data-id="element-121">recuperar esa versión de vos.</strong>
    </Fragment>, <Fragment data-id="element-122">
      Te frustrás porque bajás unos kilos y{' '}
      <strong data-id="element-123">después los volvés a subir.</strong>
    </Fragment>, <Fragment data-id="element-124">
      Te incomoda <strong data-id="element-125">sacarte la remera</strong> en la playa, piscina o
      intimidad.
    </Fragment>, <Fragment data-id="element-126">
      Te cuesta <strong data-id="element-127">mantener la constancia</strong> más de una o dos
      semanas.
    </Fragment>];
  return <section className="py-14 md:py-20 bg-zinc-900 pt-[8px] pb-[8px]" data-id="element-128">
      <div className="container mx-auto px-5 sm:px-6 md:px-8 pt-[0px] pb-[0px]" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto pt-[15px] pb-[15px]" data-id="element-130">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white md:mb-24 text-center uppercase tracking-tight leading-[0.95] mt-[10px] mb-[10px]" data-id="element-131">
            Este ebook es <span className="text-orange-500" data-id="element-132">para vos si…</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-20 md:mb-24" data-id="element-133">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} className="flex gap-5 bg-zinc-800/50 border border-zinc-700/50 p-8 rounded-2xl hover:bg-zinc-800 transition-colors pt-[32px] pb-[32px] items-start justify-start" data-id="element-134">
                <CheckCircleIcon className="w-8 h-8 text-orange-500 flex-shrink-0" data-id="element-135" />
                <p className="text-zinc-200 text-lg leading-relaxed" data-id="element-136">{point}</p>
              </motion.div>)}
          </div>

          <div className="bg-gradient-to-r from-zinc-800 to-zinc-800/50 border-l-4 border-orange-500 p-8 md:p-10 rounded-r-2xl shadow-xl pl-[32px] pr-[32px] pt-[0px] pb-[0px] mt-[-25px] mb-[-25px]" data-id="element-137">
            <p className="text-xl text-zinc-300 leading-relaxed mt-[0px] mb-[0px]" data-id="element-138">
              No necesitás tener una vida perfecta. No necesitás entrenar todos
              los días.{' '}
              <span className="italic" data-id="element-139">
                No necesitás comer pollo hervido y ensalada por 3 meses.
              </span>
            </p>
            <p className="text-2xl text-white font-bold leading-relaxed" data-id="element-140">
              Necesitás un{' '}
              <span className="text-orange-500" data-id="element-141">
                sistema claro, simple y sostenible
              </span>{' '}
              que te diga qué hacer, cómo comer, cómo moverte y cómo medir tu
              progreso.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}